import usePageMetadata from '../../hooks/usePageMetadata';

import './LegalPageLayout.css';

export const SupportEmailLink = () => (
  <a href="mailto:support@asijolab.com">support@asijolab.com</a>
);

const LegalPageLayout = ({ title, pageTitle, description, effectiveDate, children }) => {
  usePageMetadata(pageTitle, description, { robots: 'noindex, follow' });

  return (
    <article className="legalPage">
      <header className="legalPageHeader">
        <h1>{title}</h1>
        {effectiveDate && <p className="legalEffectiveDate">Effective date: {effectiveDate}</p>}
      </header>
      <div className="legalPageContent">{children}</div>
    </article>
  );
};

export default LegalPageLayout;
